// extracted by mini-css-extract-plugin
module.exports = {"HitPreview":"HitPreview_HitPreview__1H-f9","hitPreviewTitle":"HitPreview_hitPreviewTitle__g3hka","hitPreviewArtist":"HitPreview_hitPreviewArtist__qi5OC"};